export enum WhiteboardAnnotateMode {
  Text,
  Paint,
  Erase,
}

export class WhiteboardStateModel {
  enabled: boolean;
  hasPaint: boolean;
  hasText: boolean;
  brushSize: number;
  brushColor: string;
  eraserSize: number;
  textSize: number;
  annotateMode: WhiteboardAnnotateMode;
}
